import React, { FC, useContext } from "react";
import { ThemeContext } from "styled-components";
import Link from "next/link";
import { CaretIconSvg } from "../../../icons/CaretIconSvg";
import { genericKeyDownHandler } from "../../../../helpers/interactionHandlers";
import {
  StyledLink,
  StyledMenuItemAndCaret,
  StyledMenuItem,
  StyledNavMenuItemList,
} from "./index.styled";

interface NavMenuItemProps {
  id?: string;
  identifier: string;
  isMobile: boolean;
  isOpen: boolean;
  links: Link[];
  onClickHandler: React.MouseEventHandler;
  onKeyDown: React.KeyboardEventHandler;
  onMouseEnter: React.MouseEventHandler;
  onMouseLeave: React.MouseEventHandler;
  onTouchStart: React.TouchEventHandler;
  title: string;
}

interface NavMenuItemListProps {
  links: Link[];
  onClickHandler: React.MouseEventHandler;
}

interface Link {
  display: string;
  id?: string;
  url: string;
}

export const NavMenuItem: FC<NavMenuItemProps> = ({
  id,
  identifier,
  isMobile,
  isOpen,
  links,
  onClickHandler,
  onKeyDown,
  onMouseEnter,
  onMouseLeave,
  onTouchStart,
  title,
}) => {
  const theme = useContext(ThemeContext);
  return (
    <StyledMenuItem
      data-identifier={identifier}
      data-testid={`ui-header-nav-bar-menu-header-${title.replace(/ /g, "-")}`}
      id={id}
      isOpen={isOpen}
      onKeyDown={onKeyDown}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      tabIndex={0}
    >
      <StyledMenuItemAndCaret
        onTouchStart={onTouchStart}
        data-identifier={identifier}
      >
        {title}{" "}
        {isMobile && (
          <CaretIconSvg width="20" height="30" color={theme.color.disabled} />
        )}
      </StyledMenuItemAndCaret>
      {!!isOpen && (
        <NavMenuItemList links={links} onClickHandler={onClickHandler} />
      )}
    </StyledMenuItem>
  );
};

const NavMenuItemList: FC<NavMenuItemListProps> = ({
  links,
  onClickHandler,
}: NavMenuItemListProps) => {
  return (
    <StyledNavMenuItemList data-testid="ui-header-nav-menu-list">
      {links.map(({ display, url, id }, index) => {
        return (
          <StyledLink
            href={url}
            id={id}
            key={index}
            onClick={onClickHandler}
            onKeyDown={genericKeyDownHandler}
            tabIndex={0}
          >
            {display}
          </StyledLink>
        );
      })}
    </StyledNavMenuItemList>
  );
};
